import { styled } from '@lib/components';

export const SettingsSections = styled('div')`
  width: 100%;
  > div {
    margin-top: 36px;
  }
`;
